import { Badge, Button, Text, Tooltip, Transition, useMatches } from "@mantine/core";
import { CaretDown } from "../assets";

interface NewMessageButtonProps {
    shouldShow: boolean;
    shouldCollapseIfNeeded: boolean;
    num: number;
    onClick: () => void;
}

function NewNotificationBadge({
    num,
}: Omit<NewMessageButtonProps, "onClick" | "shouldShow" | "shouldCollapseIfNeeded">) {
    return (
        <Badge size="sm" circle>
            {num}
        </Badge>
    );
}

export function NewMessageButton({ shouldShow, shouldCollapseIfNeeded, num, onClick }: NewMessageButtonProps) {
    const shouldCollapseButtonText = useMatches({ base: true, lg: false }) && shouldCollapseIfNeeded;
    const newMessageButtonText = num > 1 ? "New messages" : "New message";
    return (
        <Transition duration={400} mounted={shouldShow} transition="slide-up" timingFunction="ease">
            {(transitionStyles) => (
                <Tooltip
                    label={newMessageButtonText}
                    zIndex="var(--mantine-priority-higher)"
                    disabled={!shouldCollapseButtonText}
                >
                    <Button
                        color="dark.7"
                        size="xs"
                        leftSection={!shouldCollapseButtonText && <NewNotificationBadge num={num} />}
                        onClick={onClick}
                        rightSection={<CaretDown />}
                        style={{ ...transitionStyles, border: ` 0.125rem solid var(--mantine-color-primary-7)` }}
                    >
                        {shouldCollapseButtonText ? (
                            <NewNotificationBadge num={num} />
                        ) : (
                            <Text size="xs">{newMessageButtonText}</Text>
                        )}
                    </Button>
                </Tooltip>
            )}
        </Transition>
    );
}
